// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__v1WdO","danger":"Button_danger__3JfFX","clear":"Button_clear__Vz45F"};